export function formToObj(form) {
    const jsonObject = {}
    const formData = new FormData(form)
    formData.forEach((value, key) => jsonObject[key] = value)
    return jsonObject
}

export function formToUrlEncoded(params) {
    const urlEncodedParams = new URLSearchParams();
    for (const prop in params) {
        urlEncodedParams.set(prop, params[prop]);
    }
    return urlEncodedParams
}

export function handleError(err) {
    if (err?.name === "AbortError")
        return null

    const msg = "Failed with no error messages from the server."
    return Promise.reject(err?.error || err?.err || err?.message || err?.msg || msg)
}

export function handleSuccess(resp) {
    const msg = "Failed with no error messages from the server."
    if (resp.success)
        return Promise.resolve(resp?.data)
    else
        return Promise.reject({message: resp.message || msg})
}

export function scrollToTop() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
}

function getDate(day, min) {
    return day * 24 * 60 + min
}

function flatEvents(events) {

    return events.map(event => {
        if ((event.repeat & RepeatDev.ALWAYS_MASK) !== 0) {
            return {start: 0, end: 7 * 24 * 60}
        } else if ((event.repeat & RepeatDev.DAILY_MASK) !== 0) {
            let list = []
            for (let day = 0; day < 7; day++)
                if ((event.repeat & RepeatDev.DAILY_SUN << day) !== 0)
                    list.push({start: getDate(day, event.time[0]), end: getDate(day, event.time[1])})
            return list;
        } else if ((event.repeat & RepeatDev.WEEKLY_MASK) !== 0) {
            let start_day, stop_day;
            for (let day = 0; day < 7; day++) {
                if ((event.repeat & RepeatDev.WEEKLY_START_SUN << day) !== 0)
                    start_day = day;
                if ((event.repeat & RepeatDev.WEEKLY_STOP_SUN << day) !== 0)
                    stop_day = day;
            }
            const start_min = start_day * 24 * 60 + Number(event.time[0])
            const stop_min = stop_day * 24 * 60 + Number(event.time[1])
            if (start_min < stop_min) {
                return {start: getDate(start_day, event.time[0]), end: getDate(stop_day, event.time[1])}
            } else {
                return [{start: getDate(start_day, event.time[0]), end: 7 * 24 * 60},
                    {start: 0, end: getDate(stop_day, event.time[1])}]
            }
        } else {
            return {start: 0, end: 0}
        }
    }).flat()
}

function doOverlap(event, target) {
    // EEEETTTTEEE
    if (target.start >= event.start && target.end <= event.end)
        return true
    // EEEETTTT
    if (target.start <= event.end && target.end > event.end)
        return true
    // TTTTEEEE
    if (target.start < event.start && target.end >= event.start)
        return true
    // TTTTEEEEETTTT
    if (target.start < event.start && target.end > event.end)
        return true
    return false
}


export function findOverlap(events, target) {
    let overlapFound = false

    const flattedEvents = flatEvents(events)
    const flattedTarget = flatEvents([target])

    flattedEvents.forEach(event => {
        flattedTarget.forEach(target => {
            if (doOverlap(event, target))
                overlapFound = true
        })
    })
    return overlapFound
}


function flatEvents2(events) {

    function getMinSinceMonday(day, min) {
        const temp = toggleDays.find(d => d.id === day)?.value * 24 * 60 + min
        return toggleDays.find(d => d.id === day)?.value * 24 * 60 + min
    }

    return events.map(event => {
        if (event.repeat === repeatType.Daily) {
            return event.daily.map(day => ({start: getMinSinceMonday(day, event.time_start), end: getMinSinceMonday(day, event.time_stop)}))
        } else if (event.repeat === repeatType.Weekly) {
            // const start_day = toggleDays.find(d => d.id === event.weekly_start)?.value
            // const stop_day = toggleDays.find(d => d.id === event.weekly_stop)?.value
            //
            // const start_min = getMinSinceMonday(start_day, event.time_start)
            // const stop_min = getMinSinceMonday(stop_day, event.time_stop)
            const start_min = getMinSinceMonday(event.weekly_start, event.time_start)
            const stop_min = getMinSinceMonday(event.weekly_stop, event.time_stop)
            if (start_min < stop_min) {
                return {start: start_min, end: stop_min}
            } else {
                return [{start: start_min, end: 7 * 24 * 60},
                    {start: 0, end: stop_min}]
            }
        } else {
            return {start: 0, end: 0}
        }
    }).flat()
}

export function findOverlap2(events, target) {
    let overlapFound = false

    const flattedEvents = flatEvents2(events)
    const flattedTarget = flatEvents2([target])

    flattedEvents.forEach(event => {
        flattedTarget.forEach(target => {
            if (doOverlap(event, target))
                overlapFound = true
        })
    })
    return overlapFound
}

export function getCurrentTimeString() {
    const now = new Date();
    const hours = now.getHours().toString().padStart(2, '0');
    const minutes = now.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
}
 export function currentTimeInMin() {
    const now = new Date();
    return now.getHours() * 60 + now.getMinutes()
 }

export function timeMinToString(time) {
    if (typeof time !== "number" || isNaN(time)) return null

    const hour = Math.floor(time / 60)
    const minutes = time - (hour * 60)
    return String(hour).padStart(2, "0") + ":" + String(minutes).padStart(2, "0")
}

export function timeStringToMin(time) {
    const hour = Number(time.split(":")[0]) * 60
    const minutes = Number(time.split(":")[1])
    return hour + minutes
}

// Converts minutes in UTC±0 into a local time string "HH:mm"
// 24 hours × 60 minutes/hour = 1 440 minutes
export function timeUTCMinToLocalString(utcMin) {
    const offset = new Date().getTimezoneOffset(); // in minutes
    const localMin = (utcMin - offset + 1440) % 1440;
    return timeMinToString(localMin);
}


// Converts a local time string (e.g. "13:30") to UTC±0 minutes
export function timeStringLocalToUTCMin(time) {
    const localMin = timeStringToMin(time);
    const offset = new Date().getTimezoneOffset(); // in minutes
    const temp = (localMin + offset + 1440)
    const temp2 = temp % 1440
    return (localMin + offset + 1440) % 1440; // wrap around midnight
}

export function minToVerboseTime(duration) {
    let days = Math.floor(duration / (24 * 60));
    let hours = Math.floor((duration % (24 * 60)) / 60)
    let minutes = Math.floor((duration % (24 * 60)) % 60)

    return `${days > 0 ? days + "d " : ""}${hours > 0 ? hours + "h " : ""}${minutes}m`
}

export function formatTime(seconds) {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;

    return [
        hours > 0 ? `${hours}h` : "",
        minutes > 0 ? `${minutes}m` : "",
        `${remainingSeconds}s`
    ].filter(Boolean).join(" ");
}

export function capitalizeFirstLetter(str) {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export function extractGitHubPath(url) {
    if (typeof url !== 'string') return null; // Prevent `.match` on undefined
    const match = url.match(/github\.com\/[^/]+\/[^/]+\/blob\/[^/]+\/(.+)/);
    return match ? match[1] : null;
}


export function getPriceWithVat(price, vat) {
    const v = vat == null ? 0 : vat
    const priceNumber = parseFloat(price)
    return (priceNumber + (priceNumber * v / 100)).toFixed(2)
}

export function getVat(price, vat) {
    const v = vat == null ? 0 : vat
    const priceNumber = parseFloat(price)
    return (priceNumber * v / 100).toFixed(2)
}

export function EventToDevice(repeat, start, stop) { // set
    const offset = new Date().getTimezoneOffset()

    if ((repeat & RepeatDev.ALWAYS_MASK) !== 0) {
        // nothing to do
    } else if ((repeat & RepeatDev.DAILY_MASK) !== 0) {
        const selectedDays = toggleDays.filter(i => repeat & (RepeatDev.DAILY_SUN << i.id))

        const updatedStarts = selectedDays.map(day => day.id * 24 * 60 + start + offset).map(timestamp => {
            const wDay = Math.trunc(timestamp / (24 * 60))
            const minutes = Math.trunc((timestamp % (24 * 60)))
            return {repeat: RepeatDev.DAILY_SUN << wDay, start: minutes}
        })

        const updatedStops = selectedDays.map(day => day.id * 24 * 60 + stop + offset).map(timestamp => {
            const wDay = Math.trunc(timestamp / (24 * 60))
            const minutes = Math.trunc((timestamp % (24 * 60)))
            return {repeat: RepeatDev.DAILY_SUN << wDay, stop: minutes}
        })

        const repeatDev = updatedStarts.reduce((temp, timestamp) => temp | timestamp.repeat, 0)

        return [repeatDev, updatedStarts[0].start, updatedStops[0].stop]

    } else if ((repeat & RepeatDev.WEEKLY_MASK) !== 0) {
        const minStartDay = toggleDays.find(i => repeat & (RepeatDev.WEEKLY_START_SUN << i.id)).id * 24 * 60 + start + offset
        const minStopDay = toggleDays.find(i => repeat & (RepeatDev.WEEKLY_STOP_SUN << i.id)).id * 24 * 60 + stop + offset

        const wStartDay = Math.trunc(minStartDay / (24 * 60))
        const startMinutes = Math.trunc((minStartDay % (24 * 60)))

        const wStopDay = Math.trunc(minStopDay / (24 * 60))
        const stopMinutes = Math.trunc((minStopDay % (24 * 60)))

        return [RepeatDev.WEEKLY_START_SUN << wStartDay | RepeatDev.WEEKLY_STOP_SUN << wStopDay, startMinutes, stopMinutes]

    }

    return [repeat, start, stop]
}

export function DeviceToEvent(repeat, start, stop) { // get
    const offset = new Date().getTimezoneOffset()

    if ((repeat & RepeatDev.ALWAYS_MASK) !== 0) {
        // nothing to do
    } else if ((repeat & RepeatDev.DAILY_MASK) !== 0) {
        const selectedDays = toggleDays.filter(i => repeat & (RepeatDev.DAILY_SUN << i.id))

        const updatedStarts = selectedDays.map(day => day.id * 24 * 60 + start - offset).map(timestamp => {
            const wDay = Math.trunc(timestamp / (24 * 60))
            const minutes = Math.trunc((timestamp % (24 * 60)))
            return {repeat: RepeatDev.DAILY_SUN << wDay, start: minutes}
        })

        const updatedStops = selectedDays.map(day => day.id * 24 * 60 + stop - offset).map(timestamp => {
            const wDay = Math.trunc(timestamp / (24 * 60))
            const minutes = Math.trunc((timestamp % (24 * 60)))
            return {repeat: RepeatDev.DAILY_SUN << wDay, stop: minutes}
        })

        const repeatDev = updatedStarts.reduce((temp, timestamp) => temp | timestamp.repeat, 0)

        return [repeatDev, updatedStarts[0].start, updatedStops[0].stop]

    } else if ((repeat & RepeatDev.WEEKLY_MASK) !== 0) {
        const minStartDay = toggleDays.find(i => repeat & (RepeatDev.WEEKLY_START_SUN << i.id)).id * 24 * 60 + start - offset
        const minStopDay = toggleDays.find(i => repeat & (RepeatDev.WEEKLY_STOP_SUN << i.id)).id * 24 * 60 + stop - offset

        const wStartDay = Math.trunc(minStartDay / (24 * 60))
        const startMinutes = Math.trunc((minStartDay % (24 * 60)))

        const wStopDay = Math.trunc(minStopDay / (24 * 60))
        const stopMinutes = Math.trunc((minStopDay % (24 * 60)))

        return [RepeatDev.WEEKLY_START_SUN << wStartDay | RepeatDev.WEEKLY_STOP_SUN << wStopDay, startMinutes, stopMinutes]

    }

    return [repeat, start, stop]
}

export const Mode = Object.freeze({
    UNDEFINED: Number(0),
    PLAYBACK: Number(1),
    SENDER: Number(2),
    RTP: Number(3),
    USB: Number(4),
})

export const ModeMap = [
    {id: Mode.PLAYBACK, name: "Playback", path: "playback", icon: "bi bi-headphones"},
    {id: Mode.SENDER, name: "Sender", path: "sender", icon: "bi bi-broadcast"},
    {id: Mode.RTP, name: "RTP", path: "rtp", icon: "bi bi-stopwatch"},
    {id: Mode.USB, name: "USB", path: "usb", icon: "bi bi-file-earmark-music"}
]


export const RepeatDev = {
    DAILY_SUN: (1 << 0),
    DAILY_MON: (1 << 1),
    DAILY_TUE: (1 << 2),
    DAILY_WED: (1 << 3),
    DAILY_THU: (1 << 4),
    DAILY_FRI: (1 << 5),
    DAILY_SAT: (1 << 6),

    WEEKLY_START_SUN: (1 << 7),
    WEEKLY_START_MON: (1 << 8),
    WEEKLY_START_TUE: (1 << 9),
    WEEKLY_START_WED: (1 << 10),
    WEEKLY_START_THU: (1 << 11),
    WEEKLY_START_FRI: (1 << 12),
    WEEKLY_START_SAT: (1 << 13),

    WEEKLY_STOP_SUN: (1 << 14),
    WEEKLY_STOP_MON: (1 << 15),
    WEEKLY_STOP_TUE: (1 << 16),
    WEEKLY_STOP_WED: (1 << 17),
    WEEKLY_STOP_THU: (1 << 18),
    WEEKLY_STOP_FRI: (1 << 19),
    WEEKLY_STOP_SAT: (1 << 20),

    ALWAYS: (1 << 21),

    ALWAYS_MASK: (1 << 21),
    DAILY_MASK: (0b000001111111),
    WEEKLY_MASK: (0b111111111111110000000),
    WEEKLY_START_MASK: (0b11111110000000),
    WEEKLY_END_MASK: (0b111111100000000000000),
}

export const Repeat = Object.freeze({
    ALWAYS: Number(0),
    DAILY: Number(1),
    WEEKLY: Number(2)
})

export const RepeatMap = [
    // {id: Repeat.ALWAYS, name: "Always", mask: RepeatDev.ALWAYS_MASK, icon: "bi bi-play-circle", variant: "primary"},
    {id: Repeat.DAILY, name: "Daily", mask: RepeatDev.DAILY_MASK, icon: "bi bi-arrow-repeat", variant: "primary"},
    {id: Repeat.WEEKLY, name: "Weekly", mask: RepeatDev.WEEKLY_MASK, icon: "bi bi-arrows", variant: "primary"},
]

export const repeatType = {
    Daily: "daily",
    Weekly: "weekly",
}

const weekDays = {
    Monday: "monday",
    Tuesday: "tuesday",
    Wednesday: "wednesday",
    Thursday: "thursday",
    Friday: "friday",
    Saturday: "saturday",
    Sunday: "sunday",
}


export const radiosAdc = [
    {id: 0, name: "Joint", variant: "primary", disabled: false},
    {id: 1, name: "Dual", variant: "primary", disabled: false},
    {id: 2, name: "Left", variant: "primary", disabled: false},
    {id: 3, name: "Right", variant: "primary", disabled: false},
    {id: 4, name: "Mono", variant: "primary", disabled: false}
]

export const ScheduleVal = Object.freeze({
    NONE: Number(0),
    STOP: Number(1),
    NEXT: Number(2),
    PLAY: Number(3),
})

export const StreamVal = Object.freeze({
    NOTHING: Number(0),
    STARTING: Number(1),
    STARTED: Number(2),
    STOPPING: Number(3),
    STOPPED: Number(4),
    FAILED: Number(5),
})

export const AsyncTopic = Object.freeze({
    SCHEDULE: "schedule",
    STREAM: "stream",
    RADIO: "radio",
    CODEC: "codec",
    VUMETER: "vu",
    RTC: "rtc"
})

export const toggleDays = [
    {id: "monday", day: "Mon", short: "M", long: "Monday", variant: "primary", value: 1},
    {id: "tuesday", day: "Tue", short: "T", long: "Tuesday", variant: "primary", value: 2},
    {id: "wednesday", day: "Wed", short: "W", long: "Wednesday", variant: "primary", value: 3},
    {id: "thursday", day: "Thu", short: "T", long: "Thursday", variant: "primary", value: 4},
    {id: "friday", day: "Fri", short: "F", long: "Friday", variant: "primary", value: 5},
    {id: "saturday", day: "Sat", short: "S", long: "Saturday", variant: "danger", value: 6},
    {id: "sunday", day: "Sun", short: "S", long: "Sunday", variant: "danger", value: 0},
]

export function repeatDevToRepeat(repeat) {
    if ((repeat & RepeatDev.ALWAYS_MASK) !== 0)
        return Repeat.ALWAYS
    else if ((repeat & RepeatDev.DAILY_MASK) !== 0)
        return Repeat.DAILY
    else if ((repeat & RepeatDev.WEEKLY_MASK) !== 0)
        return Repeat.WEEKLY
    else
        return null
}

export const EncodeMap = [
    {id: 0, name: "ADPCM", variant: "secondary", show: true, disabled: true},
    {id: 1, name: "PCM", variant: "secondary", show: true, disabled: true},
    {id: 2, name: "μ-law", variant: "secondary", show: true, disabled: true},
    {id: 3, name: "A-law", variant: "secondary", show: true, disabled: true},
    {id: 4, name: "G.722 ADPCM", variant: "secondary", show: false, disabled: true},
    {id: 5, name: "Ogg Vorbis", variant: "primary", show: true, disabled: false},
    {id: 6, name: "MP3", variant: "primary", show: true, disabled: false},
    {id: 7, name: "FLAC", variant: "primary", show: true, disabled: false},
]

export const DencodeMap = [
    {id: 0, name: "Undefined"},
    {id: 0x7665, name: "WAV"},
    {id: 0x4154, name: "AAC (ADTS)"},
    {id: 0x4144, name: "AAC (ADIF)"},
    {id: 0x4D34, name: "AAC (MP4)"},
    {id: 0x574D, name: "WMA"},
    {id: 0x4F67, name: "Ogg Vorbis"},
    {id: 0x664c, name: "FLAC"},
    {id: 0x4D54, name: "MIDI"},
    {id: 0x4c41, name: "LATM"},
    {id: 0x4944, name: "MP3 ID"},
    {id: 1, name: "MP3"},
]

export const ChannelMap = [
    {id: 0, name: "mono", variant: "primary", disabled: false},
    {id: 1, name: "stereo", variant: "primary", disabled: false}
]

export const MimeMap = [
    {id: 0, name: "Undefined"},
    {id: 1, name: "AAC"},
    {id: 2, name: "MP3"},
    {id: 3, name: "OGG Vorbis"},
    {id: 4, name: "WAV"},
    {id: 5, name: "FLAC"},
    {id: 6, name: "MIDI"},
]

export const timezones = [
    {offset: -660, zone: "(GMT-11:00) Samoa Standard Time; Midway Is"},
    {offset: -600, zone: "(GMT-10:00) Hawaii Standard Time"},
    {offset: -540, zone: "(GMT-09:00) Alaska Standard Time"},
    {offset: -480, zone: "(GMT-08:00) Pacific Time (US &amp; Canada); Tijuana"},
    {offset: -420, zone: "(GMT-07:00) Arizona"},
    {offset: -420, zone: "(GMT-07:00) Chihuahua, Mazatlan"},
    {offset: -420, zone: "(GMT-07:00) Mountain Time (US &amp; Canada)"},
    {offset: -360, zone: "(GMT-06:00) Central America Standard Time; Guatemala"},
    {offset: -360, zone: "(GMT-06:00) Central Time (US Canada)"},
    {offset: -360, zone: "(GMT-06:00) Mexico City; Tegucigalpa"},
    {offset: -360, zone: "(GMT-06:00) Saskatchewan"},
    {offset: -300, zone: "(GMT-05:00) Bogota, Lima, Quito, Rio Branco"},
    {offset: -300, zone: "(GMT-05:00) Eastern Time (US &amp; Canada)"},
    {offset: -300, zone: "(GMT-05:00) Indiana (East)"},
    {offset: -270, zone: "(GMT-04:30) Caracas"},
    {offset: -240, zone: "(GMT-04:00) Atlantic Time (Canada)"},
    {offset: -240, zone: "(GMT-04:00) La Paz"},
    {offset: -240, zone: "(GMT-04:00) Manaus"},
    {offset: -240, zone: "(GMT-04:00) Santiago"},
    {offset: -210, zone: "(GMT-03:30) Newfoundland"},
    {offset: -180, zone: "(GMT-03:00) Brasilia"},
    {offset: -180, zone: "(GMT-03:00) Buenos Aires, Georgetown"},
    {offset: -180, zone: "(GMT-03:00) Greenland Standard Time; Nuuk(Godthab)"},
    {offset: -180, zone: "(GMT-03:00) Montevideo"},
    {offset: -120, zone: "(GMT-02:00) Mid-Atlantic Standard Time"},
    {offset: -60, zone: "(GMT-01:00) Azores Standard Time"},
    {offset: -60, zone: "(GMT-01:00) Cape Verde Is."},
    {offset: 0, zone: "(GMT) Casablanca"},
    {offset: 0, zone: "(GMT) Dublin, Edinburgh, Lisbon, London"},
    {offset: 0, zone: "(GMT) Monrovia, Reykjavik"},
    {offset: +60, zone: "(GMT+01:00) Amsterdam, Berlin, Rome, Stockholm, Vienna"},
    {offset: +60, zone: "(GMT+01:00) Belgrade, Bratislava, Budapest, Prague"},
    {offset: +60, zone: "(GMT+01:00) Brussels, Copenhagen, Madrid, Paris, Rome"},
    {offset: +60, zone: "(GMT+01:00) Sarajevo, Skopie, Warsaw, Zagreb"},
    {offset: +60, zone: "(GMT+01:00) Western Africa Time"},
    {offset: +60, zone: "(GMT+01:00) Windhoek"},
    {offset: +120, zone: "(GMT+02:00) Amman"},
    {offset: +120, zone: "(GMT+02:00) Athens, Bucharest"},
    {offset: +120, zone: "(GMT+02:00) Beirut"},
    {offset: +120, zone: "(GMT+02:00) Egypt Standard Time; Cairo"},
    {offset: +120, zone: "(GMT+02:00) Harare, Pretoria"},
    {offset: +120, zone: "(GMT+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius"},
    {offset: +120, zone: "(GMT+02:00) Israel Standard Time; Jerusalem"},
    {offset: +120, zone: "(GMT+02:00) Central Africa Time"},
    {offset: +120, zone: "(GMT+02:00) Eastern Europe Standard Time"},
    {offset: +180, zone: "(GMT+03:00) Istanbul"},
    {offset: +180, zone: "(GMT+03:00) Minsk"},
    {offset: +180, zone: "(GMT+03:00) Baghdad"},
    {offset: +180, zone: "(GMT+03:00) Kuwait, Riyadh"},
    {offset: +180, zone: "(GMT+03:00) Nairobi"},
    {offset: +180, zone: "(GMT+03:00) Moscow, St. Petersburg, Kazan, Volgograd"},
    {offset: +210, zone: "(GMT+03:30) Iran Standard Time; Tehran"},
    {offset: +240, zone: "(GMT+04:00) Abu Dhabi, Muscat"},
    {offset: +240, zone: "(GMT+04:00) Baku"},
    {offset: +240, zone: "(GMT+04:00) Tbilisi"},
    {offset: +240, zone: "(GMT+04:00) Yerevan"},
    {offset: +270, zone: "(GMT+04:30) Afghanistan Standard Time; Kabul"},
    {offset: +300, zone: "(GMT+05:00) Karachi, Islamabad, Tashkent"},
    {offset: +300, zone: "(GMT+05:00) Ekaterinburg"},
    {offset: +330, zone: "(GMT+05:30) Bombay, Calcutta, Madras, New Delhi, Colombo"},
    {offset: +345, zone: "(GMT+05:45) Kathmandu"},
    {offset: +360, zone: "(GMT+06:00) Almaty, Astana"},
    {offset: +360, zone: "(GMT+06:00) Dhaka"},
    {offset: +360, zone: "(GMT+06:00) Novosibirsk"},
    {offset: +390, zone: "(GMT+06:30) Yangon(Rangoon)"},
    {offset: +420, zone: "(GMT+07:00) Bangkok, Hanoi, Jakarta"},
    {offset: +420, zone: "(GMT+07:00) Krasnoyarsk"},
    {offset: +480, zone: "(GMT+08:00) Taipei"},
    {offset: +480, zone: "(GMT+08:00) Beijing, Chongqing, Hong Kong, Urumqi"},
    {offset: +480, zone: "(GMT+08:00) Ulaanbaatar"},
    {offset: +480, zone: "(GMT+08:00) Kuala Lumpur, Singapore"},
    {offset: +480, zone: "(GMT+08:00) Perth"},
    {offset: +480, zone: "(GMT+08:00) Irkutsk"},
    {offset: +540, zone: "(GMT+09:00) Tokyo, Osaka, Sapporo"},
    {offset: +540, zone: "(GMT+09:00) Seoul"},
    {offset: +540, zone: "(GMT+09:00) Yakutsk"},
    {offset: +570, zone: "(GMT+09:30) Adelaide"},
    {offset: +570, zone: "(GMT+09:30) Darwin"},
    {offset: +600, zone: "(GMT+10:00) Brisbane"},
    {offset: +600, zone: "(GMT+10:00) Melbourne, Sydney, Canberra"},
    {offset: +600, zone: "(GMT+10:00) Guam, Port Moresby"},
    {offset: +600, zone: "(GMT+10:00) Tasmania Standard Time; Hobart"},
    {offset: +600, zone: "(GMT+10:00) Vladivostok"},
    {offset: +600, zone: "(GMT+10:00) Magadan, Solomon Is., New Caledonia"},
    {offset: +660, zone: "(GMT+11:00) New Caledonia"},
    {offset: +720, zone: "(GMT+12:00) Auckland, Wellington"},
    {offset: +720, zone: "(GMT+12:00) Fiji, Kamchatka, Marshall Is."}
]